var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconChevronRight = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M9.96974 8.03025C9.67724 7.73775 9.67724 7.26225 9.96974 6.96975C10.2622 6.67725 10.7377 6.6765 11.0302 6.96975L15.5302 11.4697C15.8227 11.7622 15.8227 12.2377 15.5302 12.5302L11.0302 17.0302C10.7377 17.3227 10.2622 17.3227 9.96974 17.0302C9.67724 16.7377 9.67724 16.2622 9.96974 15.9697L13.9395 12L9.96974 8.03025Z", fill: "black" }))),
        alt: 'ChevronRight',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconChevronRight;
//# sourceMappingURL=index.js.map